// extracted by mini-css-extract-plugin
export default {"header":"blogs_header__0RQa3"};